import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=0cde87f3&scoped=true&"
import script from "./Agenda.vue?vue&type=script&lang=ts&"
export * from "./Agenda.vue?vue&type=script&lang=ts&"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=0cde87f3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cde87f3",
  null
  
)

export default component.exports